import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class BinFormatPipe {
    transform(value, format = 'first4', separator = '_', replacementChar = 'X') {
        const bin = value?.replace(separator, '');
        if (!bin) {
            return '';
        }
        const getSubString = (slice) => bin.slice(...slice);
        const formatTransformations = {
            first4: `${getSubString([0, 4])} ${replacementChar.repeat(4)} ${replacementChar.repeat(4)} ${replacementChar.repeat(4)}`,
            first4_last4: `${getSubString([0, 4])} ${replacementChar.repeat(4)} ${replacementChar.repeat(4)} ${getSubString([bin?.length - 4])}`,
            first6: `${getSubString([0, 4])} ${getSubString([
                bin?.length - 2,
            ])}${replacementChar.repeat(2)} ${replacementChar.repeat(4)} ${replacementChar.repeat(4)}`,
            first6_last4: `${getSubString([0, 4])} ${getSubString([
                bin.length - 2,
            ])}${replacementChar.repeat(2)} ${replacementChar.repeat(4)} ${getSubString([bin.length - 4])}`,
            last4: `${replacementChar.repeat(4)} ${replacementChar.repeat(4)} ${replacementChar.repeat(4)} ${getSubString([bin.length - 4])}`,
            first8: `${getSubString([0, 4])} ${getSubString([
                bin.length - 4,
            ])} ${replacementChar.repeat(4)} ${replacementChar.repeat(4)}`,
            first9: `${getSubString([0, 4])} ${getSubString([
                bin.length - 4,
            ])} ${bin.substring(bin.length - 1)}${replacementChar.repeat(3)} ${replacementChar.repeat(4)}`,
            last8: `${replacementChar.repeat(4)} ${replacementChar.repeat(4)} ${getSubString([bin?.length - 8])}`,
        };
        return formatTransformations[format] || bin;
    }
}
BinFormatPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BinFormatPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
BinFormatPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: BinFormatPipe, name: "pvBinFormat" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BinFormatPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'pvBinFormat',
                }]
        }] });

class PvBinFormatModule {
}
PvBinFormatModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PvBinFormatModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PvBinFormatModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: PvBinFormatModule, declarations: [BinFormatPipe], imports: [CommonModule], exports: [BinFormatPipe] });
PvBinFormatModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PvBinFormatModule, providers: [BinFormatPipe], imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PvBinFormatModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BinFormatPipe],
                    imports: [CommonModule],
                    providers: [BinFormatPipe],
                    exports: [BinFormatPipe],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { BinFormatPipe, PvBinFormatModule };
